// src/themeConfig.js

export const Colors = {
  // --- BRAND & LAYOUT ---
  brand: {
    primary: "#2E4053", // Deep Blue-Gray (Trust)
    accent: "#1ABC9C", // Modern Teal (Action)
    background: "#F4F6F8", // Soft Slate
    surface: "#FFFFFF", // Pure White Panels
    border: "#E2E8F0", // Divider lines
  },

  // --- TEXT COLORS ---
  text: {
    main: "#2E4053",
    secondary: "#7F8C8D",
    muted: "#9CA3AF",
    onDark: "#F9FAFB",
  },

  // --- STATUS & ALERTS ---
  status: {
    success: "#27AE60",
    warning: "#F39C12",
    error: "#C0392B",
    info: "#3498DB",
    comingSoon: "#9CA3AF", // Gray for disabled features
  },

  // --- SIDEBAR SPECIFIC ---
  sidebar: {
    bg: "#1F2937",
    hover: "#374151",
    active: "#4B5563",
    iconDefault: "#D1D5DB",
    iconActive: "#4F46E5",
  },
};
